/* Actions */
import { ACTION_TYPES } from "./actions";

const initialState = {
  isFullScreen: false,
  isLandscape: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.SET_IS_FULL_SCREEN:
      return { ...state, isFullScreen: payload };
    case ACTION_TYPES.SET_IS_LANDSCAPE:
      return { ...state, isLandscape: payload };
    default:
      return state;
  }
};
